import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const MicrosoftEmbedWidgetStaticSchema = BaseWidgetSchema(WidgetType.MicrosoftEmbed).extend({
  src: z.string(),
  title: z.string(),
  documentType: z.enum(['Word', 'PowerPoint', 'Excel'])
});

export type MicrosoftEmbedWidgetStaticSchemaType = z.infer<typeof MicrosoftEmbedWidgetStaticSchema>;
